/* Cohesive icon for each gift-card brand. Renders an admin-uploaded image when
   provided via the `icon_url` prop, otherwise auto-resolves from /api/giftcards
   cache, otherwise falls back to a branded letter chip. */

import { useGiftCards, findGiftCardByCode } from "@/hooks/useGiftCards";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

const ICONS = {
    AMAZON: { label: "a", bg: "bg-black", color: "text-amber-400" },
    GOOGLE_PLAY: { label: "▶", bg: "bg-white border border-slate-200", color: "text-emerald-500" },
    APPLE: { label: "", bg: "bg-black", color: "text-white" },
    STEAM: { label: "S", bg: "bg-[#1B2838]", color: "text-white" },
    WALMART: { label: "✦", bg: "bg-[#0071CE]", color: "text-amber-300" },
    XBOX: { label: "X", bg: "bg-[#107C10]", color: "text-white" },
    PAYPAL: { label: "P", bg: "bg-[#003087]", color: "text-white" },
    ITUNES: { label: "♪", bg: "bg-[#FA243C]", color: "text-white" },
    BTC: { label: "₿", bg: "bg-orange-500", color: "text-white" },
    ETH: { label: "Ξ", bg: "bg-indigo-500", color: "text-white" },
    USDT: { label: "₮", bg: "bg-emerald-500", color: "text-white" },
    LTC: { label: "Ł", bg: "bg-blue-500", color: "text-white" },
};

function resolve(src) {
    if (!src) return null;
    if (src.startsWith("http")) return src;
    return `${BACKEND_URL}${src}`;
}

export default function GiftCardIcon({ code, size = 40, iconUrl }) {
    const cards = useGiftCards();
    const dim = `${size}px`;
    let url = resolve(iconUrl);
    if (!url && code) {
        const card = findGiftCardByCode(cards, code);
        url = resolve(card?.icon_url);
    }
    if (url) {
        return (
            <img
                src={url}
                alt={code || ""}
                className="rounded-full object-cover bg-white border border-slate-100"
                style={{ width: dim, height: dim }}
            />
        );
    }
    const cfg = ICONS[code] || { label: code?.[0] || "?", bg: "bg-slate-200", color: "text-slate-700" };
    return (
        <div
            className={`rounded-full flex items-center justify-center font-bold ${cfg.bg} ${cfg.color}`}
            style={{ width: dim, height: dim, fontSize: size * 0.5 }}
        >
            {cfg.label}
        </div>
    );
}
